export const STORAGE_CAPABILITIES = [
  'Bulk Powder',
  'Bulk Liquid',
  'Hazardous Chemicals',
  'Hazardous Other',
  'High Value',
  'LME',
  'Wet Bonded',
  'Dry Bonded',
  'Container',
  'Outdoor',
  'RF Technology',
];

export const MATERIAL_HANDLING_EQUIPMENT = [
  'Counter Balance',
  'Crane',
  'Reach Truck',
  'Trailer Parking',
  'Fork Lift',
  'Pump Truck',
  'Container Ramps',
];

export const ACCREDITATIONS = [
  'Amazon Inbound Preferred Carrier (IPCP)',
  'BRC',
  'CBP Supply Chain Security',
  'MHRA',
  'Organic Food Federation',
  'Organic Farmers and Growers',
  'SOIL',
  'UKWA',
  'Other',
];

export const SAFETY_AND_SECURITY = [
  '24/7 Security',
  '24/7 Access',
  'Bunded',
  'Caged',
  'Sprinklered',
  'Alarmed',
  'Patrolled',
  'Fenced Yard',
  'CCTV',
  'ESFR Sprinkler System',
];

export const WAREHOUSE_OPERATIONS = [
  'Receipt and Putaway',
  'Docking',
  'Picking, Packing & Despatch',
  'Domestic Fulfilment',
  'International Fulfilment',
  'Nationwide and International Distribution & Haulage',
  'Import/Export Documentation',
  'Container Devanning and Sub-sorting',
  'Temporary Container Storage',
  'Shrink Wrapping',
  'Waste Disposal',
  'Flexible Operations Schedule',
];

export const FULFILMENT_SERVICES = [
  '3rd Party Couriers',
  'Trans Loading',
  'Cross Docking',
  'Merge In Transit',
  'Returns Logistics',
  'Critical Inventory Logistics',
];

export const ADDITIONAL_SERVICES = [
  'Re-packaging, Customised Labelling, Light Assembly & Documentation',
  'Re-processing and Quality Control Programs',
  'Return processing and Management',
  'Contract Packing',
  'Procurement and Management of All Packaging Materials',
  'Product Kitting and Repackaging',
  'Contract Manufacturing',
  'Hazardous Goods handling',
  'Special Projects',
];
